export const FOLDER_CATEGORY_VALUES = [
    'films',
    'films.001',
    'films.001.rus',
    'films.cartoons',
    'films.humor',
    'films.russian',
    'films.serials',
    'films.XXX',
];
export const FILM_LANGUAGE_VALUES = ['en', 'ru', 'mixed', 'unknown'];
export const FILM_STATUS_VALUES = [
    'pending_inventory',
    'inventorying',
    'inventoried',
    'transcribing',
    'transcribed',
    'selecting_moments',
    'moments_ready',
    'error',
];
//# sourceMappingURL=film.js.map